import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../index.scss";

export const ListElement = ({ listRef, children, showCarousel }) => (
  <ul
    ref={listRef}
    className={classnames(styles.list)}
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex={showCarousel ? 0 : undefined}
  >
    {children}
  </ul>
);

ListElement.propTypes = {
  listRef: PropTypes.object,
  children: PropTypes.node,
  showCarousel: PropTypes.bool,
};
